import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PasswordValidator } from '../../validator/password.validator';
import { AuthService } from '../../service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { finalize } from 'rxjs/operators';
import { NotificationService } from '../../service/notification.service';

@Component({
  selector: 'app-change-password-profile',
  templateUrl: './change-password-profile.component.html',
  styleUrls: ['./change-password-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordProfileComponent implements OnInit {
  passwordForm: FormGroup;
  isSubmitting = false;

  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.passwordForm = this.fb.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]]
    }, {
      validators: PasswordValidator.MatchPassword
    });
  }

  changePassword(): void {
    if (!this.passwordForm.valid) { return; }
    this.isSubmitting = true;
    this.authService.passwordChange({
      oldPassword: this.passwordForm.value.oldPassword,
      newPassword1: this.passwordForm.value.password,
      newPassword2: this.passwordForm.value.confirmPassword
    })
    .pipe(finalize(() => { this.isSubmitting = false; this.cdr.markForCheck(); }))
    .subscribe(() => {
      this.notificationService.notify('profile.password-changed');
      this.initForm();
      this.cdr.markForCheck();
    });
  }

  discardChanges(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'admin.event.settings.discard-changes-dialog.title',
        content: 'admin.event.settings.discard-changes-dialog.content',
        confirm: 'forms.buttons.discard',
        cancel: 'forms.buttons.cancel',
        destructive: true,
      }
    }).afterClosed().subscribe(confirmed => {
      if (!confirmed) { return; }
      this.initForm();
      this.cdr.markForCheck();
    });
  }

  get passwordFormIsValid(): boolean {
    return this.passwordForm.valid;
  }

  isFieldInvalid(name: string): boolean {
    const ctrl = this.passwordForm?.controls[name];
    if (!ctrl) { return false; }
    return ctrl.invalid && (ctrl.dirty || ctrl.touched);
  }
}
